import { render, staticRenderFns } from "./Authorized.vue?vue&type=template&id=0255b1a3&"
import script from "./Authorized.vue?vue&type=script&lang=ts&"
export * from "./Authorized.vue?vue&type=script&lang=ts&"
import style0 from "./Authorized.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports